var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSave01 = function SvgIconSave01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_save-01_svg2__a",
    x1: -5.92,
    x2: 55.79,
    y1: 81.76,
    y2: 29.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_save-01_svg2__a",
    id: "icon_save-01_svg2__b",
    x1: 15.15,
    x2: 76.86,
    y1: 106.64,
    y2: 54.37
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.44 62.34A9.23 9.23 0 0 0 50 65.05c2.46 0 4.82-.97 6.56-2.71l19.57-19.57a3.61 3.61 0 0 0 0-5.03 3.62 3.62 0 0 0-5.12-.09L53.63 55.03V5.61c0-2-1.62-3.62-3.62-3.62s-3.62 1.62-3.62 3.62v49.41L29.01 37.64a3.627 3.627 0 0 0-5.12 0 3.627 3.627 0 0 0 0 5.12l19.57 19.57Z",
    style: {
      fill: "url(#icon_save-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.38 59.45c-2 0-3.62 1.62-3.62 3.62V88.4c0 1.3-1.06 2.36-2.36 2.36H9.61c-1.3 0-2.36-1.06-2.36-2.36V63.07c0-2-1.62-3.62-3.62-3.62S.01 61.07.01 63.07V88.4c0 5.3 4.3 9.6 9.61 9.61h80.79c5.3 0 9.6-4.3 9.61-9.61V63.07c0-2-1.62-3.62-3.62-3.62Z",
    style: {
      fill: "url(#icon_save-01_svg2__b)"
    }
  }));
};
export default SvgIconSave01;